import selectors from './selectors'
import slice from './slice'
import thunks from './thunks'

export {
  slice as ogeSubjectsSlice,
  selectors as ogeSubjectsSelectors,
  thunks as ogeSubjectsThunks,
}
